export const mediaItems = [
  {
    id: 1,
    title: "某千万粉颜值博主深夜直播痛哭，疑似与经纪公司解约纠纷升级",
    tag: "独家爆料",
    views: "128.6万",
    time: "3小时前",
    duration: "04:32",
    image: "https://readdy.ai/api/search-image?query=Dramatic%20editorial%20photography%20with%20warm%20orange%20spotlight%20on%20abstract%20figure%2C%20breaking%20news%20atmosphere%2C%20entertainment%20media%20visual%2C%20dark%20background%20with%20warm%20highlights%2C%20journalism%20style&width=400&height=250&seq=media-1-baoliao&orientation=landscape"
  },
  {
    id: 2,
    title: "知名带货主播被曝数据造假，后台真实转化率不足宣称的十分之一",
    tag: "行业黑幕",
    views: "96.3万",
    time: "5小时前",
    duration: "06:18",
    image: "https://readdy.ai/api/search-image?query=Abstract%20business%20data%20chart%20visual%20with%20warm%20dramatic%20lighting%2C%20editorial%20news%20style%2C%20orange%20and%20cream%20color%20palette%2C%20mysterious%20atmosphere%2C%20corporate%20scandal%20theme&width=400&height=250&seq=media-2-baoliao&orientation=landscape"
  },
  {
    id: 3,
    title: "短视频平台头部达人集体停更，知情人士透露与新一轮分成政策有关",
    tag: "热点追踪",
    views: "87.1万",
    time: "7小时前",
    duration: "03:55",
    image: "https://readdy.ai/api/search-image?query=Multiple%20silhouettes%20standing%20in%20dramatic%20warm%20lighting%2C%20protest%20or%20strike%20atmosphere%2C%20editorial%20photojournalism%20style%2C%20orange%20and%20red%20accents%2C%20warm%20cream%20background&width=400&height=250&seq=media-3-baoliao&orientation=landscape"
  },
  {
    id: 4,
    title: "户外主播探险途中遭遇惊险一幕，直播间百万人同时目睹全过程",
    tag: "现场直击",
    views: "215.2万",
    time: "9小时前",
    duration: "08:47",
    image: "https://readdy.ai/api/search-image?query=Adventure%20and%20danger%20dramatic%20scene%20with%20warm%20lighting%2C%20outdoor%20atmosphere%2C%20breaking%20news%20visual%20style%2C%20coral%20and%20cream%20tones%2C%20photojournalism%20aesthetic&width=400&height=250&seq=media-4-baoliao&orientation=landscape"
  },
  {
    id: 5,
    title: "美食区顶流翻车实录：探店视频中被店家当场揭穿剧本台词",
    tag: "翻车现场",
    views: "173.8万",
    time: "12小时前",
    duration: "05:21",
    image: "https://readdy.ai/api/search-image?query=Restaurant%20interior%20with%20dramatic%20warm%20lighting%2C%20confrontation%20atmosphere%2C%20editorial%20news%20style%2C%20orange%20and%20cream%20palette%2C%20expose%20theme%20visual&width=400&height=250&seq=media-5-baoliao&orientation=landscape"
  },
];

export const cardItems = [
  {
    id: 1,
    title: "某选秀出身偶像被前经纪人实名举报，涉及金额超千万",
    category: "娱乐圈",
    summary: "一封实名举报信在社交平台疯传，前经纪人列举多项违约及财务问题，引发粉丝圈震动。当事人暂未回应，但其工作室连夜发布律师函。",
    time: "2小时前",
    hot: true,
    image: "https://readdy.ai/api/search-image?query=Legal%20document%20and%20spotlight%20dramatic%20scene%2C%20editorial%20news%20photography%20style%2C%20warm%20orange%20and%20cream%20tones%2C%20celebrity%20scandal%20atmosphere%2C%20confrontation%20visual&width=400&height=260&seq=card-1-baoliao&orientation=landscape"
  },
  {
    id: 2,
    title: "直播带货一姐选品团队核心成员离职，带走大量品牌资源",
    category: "直播圈",
    summary: "据内部员工透露，该成员系选品部门负责人，离职后已入职竞争对手平台，数十个独家合作品牌面临重新谈判。",
    time: "4小时前",
    hot: true,
    image: "https://readdy.ai/api/search-image?query=Corporate%20office%20with%20dramatic%20lighting%2C%20employee%20leaving%20atmosphere%2C%20editorial%20photojournalism%2C%20warm%20coral%20and%20cream%20palette%2C%20business%20drama%20visual&width=400&height=260&seq=card-2-baoliao&orientation=landscape"
  },
  {
    id: 3,
    title: "网红情侣分手上热搜，双方粉丝互撕升级为全网热议话题",
    category: "八卦圈",
    summary: "两人在社交平台互相取关并删除合照后，各自发布暗示性动态，引发两方粉丝大规模论战，话题阅读量已破五亿。",
    time: "6小时前",
    hot: false,
    image: "https://readdy.ai/api/search-image?query=Broken%20heart%20abstract%20visual%20with%20warm%20dramatic%20lighting%2C%20social%20media%20drama%20atmosphere%2C%20editorial%20style%2C%20orange%20and%20cream%20tones%2C%20relationship%20scandal%20theme&width=400&height=260&seq=card-3-baoliao&orientation=landscape"
  },
  {
    id: 4,
    title: "短视频平台推出新规限制PK打赏，多位头部主播收入腰斩",
    category: "行业动态",
    summary: "新规要求所有PK类直播必须设置单场打赏上限，且未成年人禁止参与打赏。多位依赖PK收入的头部主播表示将转型内容方向。",
    time: "8小时前",
    hot: false,
    image: "https://readdy.ai/api/search-image?query=Policy%20document%20and%20digital%20screen%20abstract%2C%20regulation%20theme%20visual%2C%20editorial%20news%20style%2C%20warm%20orange%20and%20cream%20tones%2C%20platform%20governance%20atmosphere&width=400&height=260&seq=card-4-baoliao&orientation=landscape"
  },
  {
    id: 5,
    title: "探店赛道再爆丑闻：某百万粉博主收钱做虚假好评被商家曝光",
    category: "黑料实锤",
    summary: "商家公开了完整的聊天记录和转账凭证，显示该博主收取费用后发布不实好评。平台已对该账号做出限流处罚，但博主粉丝仍在维护。",
    time: "10小时前",
    hot: true,
    image: "https://readdy.ai/api/search-image?query=Payment%20transaction%20and%20chat%20evidence%20dramatic%20visual%2C%20expose%20and%20scandal%20atmosphere%2C%20editorial%20photojournalism%2C%20warm%20coral%20and%20cream%20palette%2C%20investigation%20theme&width=400&height=260&seq=card-5-baoliao&orientation=landscape"
  },
  {
    id: 6,
    title: "MCN机构内部培训资料外泄：揭秘网红人设包装全流程",
    category: "深度揭秘",
    summary: "一份近百页的培训PPT在网络流传，详细记录了从素人筛选、人设定位、内容策划到危机公关的完整流程，引发行业内外广泛讨论。",
    time: "14小时前",
    hot: false,
    image: "https://readdy.ai/api/search-image?query=Leaked%20document%20and%20magnifying%20glass%20dramatic%20visual%2C%20investigation%20journalism%20style%2C%20warm%20orange%20and%20cream%20tones%2C%20secret%20exposed%20atmosphere%2C%20editorial%20photography&width=400&height=260&seq=card-6-baoliao&orientation=landscape"
  },
];

export const faqItems = [
  { q: "爆料网的信息来源可靠吗？", a: "爆料网内容来源包括公开社交平台信息、行业内部人士投稿以及媒体报道整合。我们会对每条信息进行多方交叉验证，但仍建议读者理性看待，以官方渠道发布的最终信息为准。标注「独家爆料」的内容为本站经核实后首发。" },
  { q: "如何向爆料网投稿或爆料？", a: "您可以通过本站「投稿爆料」模块提交线索，也可发送邮件至我们的投稿邮箱。我们承诺对所有爆料人信息严格保密。如爆料内容经核实属实且具有新闻价值，我们将第一时间发布并给予适当奖励。" },
  { q: "爆料网的内容更新频率是怎样的？", a: "爆料网实行7×24小时滚动更新机制，编辑团队全天候监控各大社交平台、直播间及行业动态，确保每日至少更新数十条新鲜瓜料。重大突发事件通常可在30分钟内上线报道。" },
  { q: "被爆料的内容如果涉及不实信息怎么办？", a: "我们设有完善的申诉和更正机制。如果您认为本站发布的某一内容存在事实性错误或侵犯了您的合法权益，请通过「投稿爆料」模块提交申诉材料。经核实后，我们将在24小时内做出回应并标注更正说明。" },
  { q: "爆料网有移动端App吗？", a: "爆料网目前支持移动端H5访问，适配各类手机浏览器。您可以在页面底部「移动吃瓜」区域扫码体验移动版。专属App正在紧锣密鼓开发中，敬请期待。" },
];

export const indexItems = [
  { id: 1, title: "2025网红翻车年鉴", count: "36篇", desc: "盘点本年度最具影响力的网红翻车事件" },
  { id: 2, title: "直播带货风云录", count: "28篇", desc: "头部主播的起落与直播电商的规则变迁" },
  { id: 3, title: "MCN江湖实录", count: "22篇", desc: "揭秘国内头部MCN机构的运营内幕与竞争格局" },
  { id: 4, title: "选秀偶像后时代", count: "19篇", desc: "选秀节目停播后偶像们的转型之路全追踪" },
  { id: 5, title: "短视频平台暗战", count: "25篇", desc: "抖音快手视频号三国杀的幕后故事与策略分析" },
  { id: 6, title: "网红餐饮生死局", count: "15篇", desc: "那些开餐厅的网红们，从开业火爆到关门歇业" },
  { id: 7, title: "粉丝经济深度调查", count: "21篇", desc: "应援、打榜、氪金——粉丝文化的产业链解剖" },
  { id: 8, title: "海外网红中国行", count: "12篇", desc: "外国网红来华发展现状、机遇与文化碰撞实录" },
];

export const updatesItems = [
  { id: 1, date: "07-29 18:30", title: "突发：某平台头部游戏主播因涉嫌赌博被警方带走调查", tag: "突发" },
  { id: 2, date: "07-29 16:15", title: "三大MCN机构联合发布自律公约，承诺不制造虚假人设", tag: "行业" },
  { id: 3, date: "07-29 14:00", title: "文旅部新规：网红探店需明确标注商业推广性质", tag: "政策" },
  { id: 4, date: "07-29 11:45", title: "某知名美妆博主自创品牌被爆成分与宣传严重不符", tag: "翻车" },
  { id: 5, date: "07-29 09:20", title: "短视频平台上线AI内容识别系统，批量下架违规视频超百万条", tag: "平台" },
  { id: 6, date: "07-28 22:10", title: "前顶流网红转型实业获亿元融资，新项目估值超十亿", tag: "转型" },
  { id: 7, date: "07-28 19:55", title: "直播电商新规征求意见稿发布，或将要求主播持证上岗", tag: "政策" },
];

export const commentsItems = [
  { id: 1, user: "吃瓜不嫌事大", avatar: "C", content: "这个瓜我是从头追到尾的，看到最新进展只能说贵圈真乱。不过有一说一，爆料网整理的时间线确实清晰，比我自己东看西看强多了。", likes: 2836, time: "1小时前" },
  { id: 2, user: "理性看热闹", avatar: "L", content: "建议大家别急着站队，等双方都出来说话再下结论。现在反转的瓜太多了，前天那个不就被打脸了吗？保持吃瓜心态就好。", likes: 1921, time: "2小时前" },
  { id: 3, user: "八卦研究生", avatar: "B", content: "做了个简单的统计，今年上半年头部网红翻车的频率是去年同期的1.8倍。直播带货、人设崩塌、税务问题三座大山，谁也逃不掉。", likes: 3402, time: "3小时前" },
  { id: 4, user: "前MCN打工人", avatar: "M", content: "作为曾经的业内人士说一句，爆料网说的MCN内幕大部分都是真的。我待过两家头部机构，有些事情比爆出来的还要离谱。离职签了保密协议，只能说到这里了。", likes: 5678, time: "4小时前" },
  { id: 5, user: "深夜吃瓜人", avatar: "S", content: "每天晚上睡前都要来爆料网刷一遍，不然第二天跟同事都没话题聊了。建议出一个每日瓜料速览的功能，太长不看版的那种。", likes: 1456, time: "5小时前" },
];

export const carouselItems = [
  {
    id: 1,
    title: "2025上半年网红翻车大盘点：谁倒下了，谁还在撑？",
    subtitle: "深度专题",
    desc: "从税务风波到人设崩塌，从直播翻车到法律纠纷，我们梳理了上半年最具代表性的三十余起网红翻车事件，分析背后的行业共性与个体差异。",
    tag: "重磅策划",
    image: "https://readdy.ai/api/search-image?query=Collage%20of%20dramatic%20news%20headlines%20with%20warm%20orange%20and%20red%20tones%2C%20breaking%20news%20montage%20style%2C%20editorial%20magazine%20cover%20vibe%2C%20warm%20cream%20background%2C%20scandal%20and%20expose%20theme%2C%20journalism%20aesthetic&width=900&height=420&seq=carousel-1-baoliao&orientation=landscape"
  },
  {
    id: 2,
    title: "MCN机构权力榜：谁在掌控你关注的每一个网红？",
    subtitle: "行业调查",
    desc: "国内头部MCN机构的真实实力和幕后故事，从资本背景、签约达人规模、营收能力到争议事件，全方位揭秘这个操控千万级流量的隐形帝国。",
    tag: "独家调查",
    image: "https://readdy.ai/api/search-image?query=Corporate%20empire%20and%20network%20diagram%20abstract%20visual%2C%20power%20structure%20theme%2C%20warm%20orange%20and%20cream%20palette%2C%20editorial%20magazine%20layout%2C%20business%20investigation%20atmosphere%2C%20dramatic%20lighting&width=900&height=420&seq=carousel-2-baoliao&orientation=landscape"
  },
  {
    id: 3,
    title: "从素人到顶流：一个网红的「标准」制造流程",
    subtitle: "深度揭秘",
    desc: "我们获取了一份MCN内部培训手册，完整还原了一个素人如何经过人设定位、内容策划、数据运营和商业变现四个阶段被打造成百万粉丝的「网红」。",
    tag: "内幕曝光",
    image: "https://readdy.ai/api/search-image?query=Factory%20production%20line%20metaphor%20with%20abstract%20figures%2C%20manufacturing%20process%20visual%2C%20warm%20orange%20and%20cream%20tones%2C%20editorial%20photojournalism%2C%20behind%20the%20scenes%20expose%20theme&width=900&height=420&seq=carousel-3-baoliao&orientation=landscape"
  },
  {
    id: 4,
    title: "直播电商的下半场：当流量红利消退后谁会裸泳？",
    subtitle: "趋势分析",
    desc: "随着监管收紧、用户疲劳感增加以及品牌自播崛起，曾经的直播带货造富神话正在退潮。我们对话多位从业者，预判行业下一个五年的走向。",
    tag: "前瞻观察",
    image: "https://readdy.ai/api/search-image?query=Ocean%20wave%20receding%20metaphor%20with%20warm%20dramatic%20sunset%20lighting%2C%20business%20trend%20visual%2C%20orange%20and%20cream%20palette%2C%20editorial%20magazine%20style%2C%20future%20prediction%20theme&width=900&height=420&seq=carousel-4-baoliao&orientation=landscape"
  },
];

export const rankingItems = [
  { id: 1, rank: 1, title: "千万粉博主解约纠纷持续发酵，多方当事人发声", heat: "🔥🔥🔥🔥🔥", views: "582万" },
  { id: 2, rank: 2, title: "MCN内部培训资料外泄事件全追踪", heat: "🔥🔥🔥🔥🔥", views: "476万" },
  { id: 3, rank: 3, title: "前MCN打工人匿名爆料帖引发全网热议", heat: "🔥🔥🔥🔥", views: "398万" },
  { id: 4, rank: 4, title: "头部带货主播数据造假证据链完整公开", heat: "🔥🔥🔥🔥", views: "351万" },
  { id: 5, rank: 5, title: "探店博主收钱发虚假好评录音曝光", heat: "🔥🔥🔥", views: "287万" },
];

export const topicsItems = [
  { id: 1, name: "网红翻车", count: "2.8万讨论", hot: true },
  { id: 2, name: "MCN内幕", count: "1.6万讨论", hot: true },
  { id: 3, name: "直播带货", count: "3.2万讨论", hot: true },
  { id: 4, name: "人设崩塌", count: "2.1万讨论", hot: true },
  { id: 5, name: "数据造假", count: "1.2万讨论", hot: false },
  { id: 6, name: "网红解约", count: "9800讨论", hot: false },
  { id: 7, name: "税务风波", count: "1.5万讨论", hot: false },
  { id: 8, name: "粉丝互撕", count: "2.3万讨论", hot: true },
  { id: 9, name: "探店打假", count: "8700讨论", hot: false },
  { id: 10, name: "行业新规", count: "1.1万讨论", hot: false },
  { id: 11, name: "素人造星", count: "6500讨论", hot: false },
];

export const featuresItems = [
  { id: 1, icon: "ri-flashlight-line", title: "极速爆料", desc: "7×24小时全天候监控各大平台，重大瓜料30分钟内上线，让你永远快人一步吃到最新鲜的瓜。" },
  { id: 2, icon: "ri-shield-check-line", title: "多重核实", desc: "每条爆料均经过编辑团队多方交叉验证，标注信息来源和可信度等级，不传谣不信谣。" },
  { id: 3, icon: "ri-file-list-3-line", title: "深度专题", desc: "不止于碎片化爆料，更有深度调查、时间线梳理和行业分析，让你看懂瓜料背后的故事。" },
  { id: 4, icon: "ri-user-voice-line", title: "全网投稿", desc: "开放用户投稿通道，爆料人身份严格保密，优质线索一经采用即付稿酬，共建吃瓜社区。" },
];